module.exports = __webpack_public_path__ + "static/media/LTC.96c55614.svg";